import { useQuery } from '@tanstack/react-query'

import { paymentQueries } from '@/entities/payment'

export const useTossPaymentWidgetInfo = (contractId: number) => {
  const { data: widgetInfo } = useQuery({
    ...paymentQueries.tossPaymentWidgetInfo(contractId),
    throwOnError: true,
    meta: {
      useCustomHandling: true,
    },
  })

  return {
    widgetInfo,
  }
}
